export const getDeliveryPreferences = user => {
  return user?.attributes?.profile?.publicData?.deliveryPreferences;
};

export const getShippingAddress = user => {
  return user?.attributes?.profile?.privateData?.shippingAddress || {};
};

export const getSecurityDepositAmount = l => {
  return l?.attributes?.publicData?.securityDeposit;
};

export const getTxShippingAddress = t => {
  return t?.attributes?.protectedData?.shippingParams?.shippingAddress?.selectedPlace;
};

export const getMatchedDeliveryOptions = (shippingPrefrenceOptions, deliveryOptions) => {
  const deliveryOptionsArray = Array.isArray(deliveryOptions) ? deliveryOptions : [deliveryOptions];
  return shippingPrefrenceOptions.filter(option => deliveryOptionsArray.includes(option.value));
};
